import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { getApiUrl } from '../../config/env';

const RecaptchaSettings = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [configId, setConfigId] = useState<number | null>(null);
  const [formData, setFormData] = useState({
    siteKey: '',
    secretKey: '',
    isActive: false
  });

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const response = await fetch(getApiUrl('/recaptchaconfig'), {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        if (data && data.id) {
          setConfigId(data.id);
          setFormData({
            siteKey: data.siteKey || '',
            secretKey: data.secretKey || '',
            isActive: data.isActive
          });
        }
      }
    } catch (error) {
      console.error('Error fetching recaptcha config', error);
      toast.error('Failed to load configuration');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!configId) {
      toast.error('Configuration ID not found');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(getApiUrl(`/recaptchaconfig/${configId}`), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        toast.success('Configuration saved successfully');
      } else {
        toast.error('Failed to save configuration');
      }
    } catch (error) {
      console.error('Error saving config', error);
      toast.error('Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-4">
      <h2 className="mb-4">Google reCAPTCHA Settings</h2>
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Site Key</label>
              <input
                type="text"
                name="siteKey"
                className="form-control"
                value={formData.siteKey}
                onChange={handleChange}
                placeholder="Enter Site Key"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Secret Key</label>
              <input
                type="text"
                name="secretKey"
                className="form-control"
                value={formData.secretKey}
                onChange={handleChange}
                placeholder="Enter Secret Key"
              />
            </div>

            <div className="mb-4 form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="isActive-switch"
                name="isActive"
                checked={formData.isActive}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="isActive-switch">
                Enable reCAPTCHA validation on Customer App
              </label>
            </div>

            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Saving...' : 'Save Settings'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RecaptchaSettings;
